import { format } from "date-fns";

export function HandleAudienceTime(
    userPreference,
    setHoraIniCalendar,
    setHoraFinCalendar
  ) {
    let HoraIni: string = "",
      HoraFin: string = "";
    let result = { HoraIni, HoraFin };
  
    if (userPreference) {
      let DtIni: Date, DtFin: Date;
      let currentDate = new Date();
      //userPreference
      DtIni = new Date(userPreference.HorarioIni);
      DtFin = new Date(userPreference.Horario);
      result.HoraIni = userPreference.HorarioIni.split("T")[1].substring(0, 5);
      result.HoraFin = userPreference.Horario.split("T")[1].substring(0, 5);
      //HoraIni
      if (userPreference.ChangeAutoUpdate === true && DtIni < new Date()) {
        let dtIniCurrent = new Date();
        dtIniCurrent.setHours(parseInt("06"), parseInt("00"), 0);
        result.HoraIni = format(dtIniCurrent, "HH:mm");
        let dateHFin = new Date();
        if (DtFin < new Date()) {
          dateHFin.setMinutes(dateHFin.getMinutes() - 1);
          result.HoraFin = format(dateHFin, "HH:mm");
        }
      }
      //HoraFin
      if (userPreference.ChangeAutoUpdate === true) {
        currentDate = new Date();
        result.HoraFin = format(
          currentDate.setMinutes(new Date().getMinutes() - 1),
          "HH:mm"
        );
      }
    }
    if (result.HoraIni !== "") setHoraIniCalendar(result.HoraIni);
    if (result.HoraFin !== "") setHoraFinCalendar(result.HoraFin);
    return result;
  }


  export function HandleAudienceTimeDoAudience(
    userPreference,
    lastMinute,
    setHoraFinCalendar,
    setHoraIniCalendar,
    audienceMediaFirstTable,
    origem
  ) {
    let HoraIni: string = "",
      HoraFin: string = "";
    let lastMinuteParts: any;
    let resultHoraFim: string = "";
    let result = { HoraIni, HoraFin };
    let currentDate = new Date();
    let currentDateLastMinute = new Date();
    if (
      userPreference &&
      lastMinute &&
      userPreference.ChangeAutoUpdate === true
    ) {
      lastMinuteParts = lastMinute?.split("-");
      if (lastMinuteParts.length === 1) {
        resultHoraFim = lastMinuteParts[0].substring(0, 5);
      }
      if (lastMinuteParts.length === 2) {
        resultHoraFim = lastMinuteParts[1].replace(" ", "").substring(0, 5);
      }
      currentDateLastMinute = new Date();
      currentDateLastMinute.setHours(
        parseInt(resultHoraFim.split(":")[0]),
        parseInt(resultHoraFim.split(":")[1])
      );
      let dtCurrentLessMinute = new Date();
      dtCurrentLessMinute.setMinutes(dtCurrentLessMinute.getMinutes() - 1);
      if (currentDateLastMinute < dtCurrentLessMinute) {
        currentDate = new Date();
        currentDate.setMinutes(currentDate.getMinutes() - 1);
        resultHoraFim = format(currentDate, "HH:mm");
      } else {
        resultHoraFim = format(currentDateLastMinute, "HH:mm");
      }
    }
    result.HoraFin = resultHoraFim;
    if (result.HoraFin !== "") setHoraFinCalendar(result.HoraFin);
  }
  